var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{class:['text-center', _vm.centered]},[_c('i',{staticClass:"fas fa-circle-notch fa-spin fa-2x loader"}),_vm._v(" "),(_vm.message)?_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c50d50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Loader.vue
// module id = null
// module chunks = 